import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import type { SizeType } from "ant-design-vue/es/config-provider";
import MaskedInput from "./MaskedInput.vue";

interface Props {
  modelValue?: string;
  placeholder?: string;
  disabled?: boolean;
  size?: SizeType;
  allowClear?: boolean;
  status?: "" | "error" | "warning";
  unmasked?: boolean;
  validateOnBlur?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CccdInput',
  props: {
    modelValue: { default: "" },
    placeholder: { default: "Nhập CCCD (12 số)" },
    disabled: { type: Boolean, default: false },
    size: { default: "middle" },
    allowClear: { type: Boolean, default: true },
    status: { default: "" },
    unmasked: { type: Boolean, default: true },
    validateOnBlur: { type: Boolean, default: true }
  },
  emits: ["update:modelValue", "change", "blur", "pressEnter", "validate"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isValidCccd = (value: string) => {
  if (!value) return true;
  return /^\d{12}$/.test(value);
};

const localError = computed(() => {
  if (!props.validateOnBlur) return false;
  return !!props.modelValue && !isValidCccd(props.modelValue);
});

const computedStatus = computed(() => props.status || (localError.value ? "error" : ""));

const innerValue = computed({
  get: () => props.modelValue ?? "",
  set: (val: string) => {
    emit("update:modelValue", val);
    emit("change", val);
  },
});

const onChange = (val: string) => {
  emit("update:modelValue", val);
  emit("change", val);
};

const onBlur = (e: FocusEvent) => {
  emit("validate", isValidCccd(props.modelValue ?? ""));
  emit("blur", e);
};

const onPressEnter = (e: KeyboardEvent) => emit("pressEnter", e);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MaskedInput, {
    modelValue: innerValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((innerValue).value = $event)),
    preset: "cccd",
    placeholder: _ctx.placeholder,
    disabled: _ctx.disabled,
    size: _ctx.size,
    "allow-clear": _ctx.allowClear,
    status: computedStatus.value,
    unmasked: _ctx.unmasked,
    onBlur: onBlur,
    onPressEnter: onPressEnter,
    onChange: onChange
  }, null, 8, ["modelValue", "placeholder", "disabled", "size", "allow-clear", "status", "unmasked"]))
}
}

})